import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaHeart } from 'react-icons/fa';

function PostCard({ post, onFavorite, isFavorite }) {
  return (
    <div className="post-card">
      <img src={post.image} alt={post.title} className="post-image" />
      <div className="post-content">
        <h3 className="post-title">{post.title}</h3>
        <div className="post-meta">
          <span>{post.date}</span>
          <span>{post.author}</span>
        </div>
        <p className="post-excerpt">{post.excerpt}</p>
        <div className="post-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            <FaShoppingCart /> Διαβάστε περισσότερα
          </Link>
          <button 
            className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
            onClick={() => onFavorite(post.id)}
          >
            <FaHeart /> {isFavorite ? 'Αποθηκευμένο' : 'Αποθήκευση'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostCard;